import firebaseapp from 'firebase/app';
import 'firebase/messaging';
import firebase from '@/plugins/firebase';
import errorHandler from '@/mixins/errorHandler';
import { post } from '@/services/Axios';
import qs from 'qs';

export default {
  mixins: [errorHandler],
  computed: {
    token() {
      return this.$store.state.token;
    }
  },
  methods: {
    tokenFirebase() {
      if (firebase.messaging.isSupported()) {
        if (!this.token) {
          navigator.permissions
            .query({ name: 'notifications' })
            .then(function(result) {
              if (result.state === 'granted') {
                firebaseapp
                  .messaging()
                  .getToken()
                  .then((oldToken) => {
                    if (oldToken === localStorage.getItem('TOKEN_FCM')) {
                      firebaseapp.messaging().deleteToken(oldToken);
                      localStorage.setItem('TOKEN_FCM', '');
                    }
                  });
              }
            });
        } else {
          navigator.permissions
            .query({ name: 'notifications' })
            .then(function(result) {
              if (result.state !== 'granted') {
                firebaseapp
                  .messaging()
                  .requestPermission()
                  .then(function() {
                    window.location.reload();
                  })
                  .catch(function() {
                    // eslint-disable-next-line no-console
                    console.warn('User Menolak akses notifikasi');
                  });
              }
            });
          firebaseapp
            .messaging()
            .getToken()
            .then((refreshedToken) => {
              // eslint-disable-next-line no-console
              console.log(refreshedToken);
              this.updateTokenFirebase(refreshedToken);
            })
            .catch(function(e) {
              // eslint-disable-next-line no-console
              console.error(e);
            });
        }
      }
    },
    async updateTokenFirebase(refreshedToken) {
      if (refreshedToken !== localStorage.getItem('TOKEN_FCM')) {
        const requestBody = {
          fcm: refreshedToken
        };
        const payload = qs.stringify(requestBody);
        await post(`firebase/update`, {
          data: payload
        }).then(() => {
          localStorage.setItem('TOKEN_FCM', refreshedToken);
        });
      }
    }
  }
};
